<template>
  <div>
    <div
      v-if="
        !formdata.hideFromMember ||
          (formdata.hideFromMember == true &&
            memberData.verification != 'มี Tax ID')
      "
    >
      <div
        class="mb-2 mt-8 "
        v-if="['หัวข้อ', 'title', 'พารากราฟ'].includes(formdata.questiontype)"
      >
        <template v-if="['พารากราฟ'].includes(formdata.questiontype)">
          <Typography h5 semiBold :text="formdata.name" class="mb-2" />
          <!-- <p style="white-space: pre-line">{{ formdata.name }}</p> -->
        </template>
        <template v-if="['หัวข้อ', 'title'].includes(formdata.questiontype)">
          <Typography
            semiBold
            fontSize="fs28"
            :text="formdata.name"
            class="mb-2"
          />
          <v-divider></v-divider>
        </template>
      </div>
      <div v-else>
        <Typography h5 semiBold :text="formdata.name" class="mb-2" />
      </div>
      <ValidationProvider
        :vid="vid"
        :name="formdata.name"
        :key="formdata.name"
        :rules="{
          required: formdata.isRequired,
        }"
        v-slot="{ errors }"
      >
        <div
          v-if="
            ['ข้อความ', 'กล่องข้อความ', 'คำตอบสั้นๆ'].includes(
              formdata.questiontype
            )
          "
        >
          <v-textarea
            :readonly="isReadonly"
            :disabled="isReadonly"
            :error-messages="errors"
            :value="value"
            @input="onInput"
            rows="1"
            outlined
            dense
            class="textarea-custom radius-5"
          >
          </v-textarea>
        </div>
        <div v-else-if="formdata.questiontype == 'หลายตัวเลือก'">
          <v-radio-group
            :readonly="isReadonly"
            :disabled="isReadonly"
            :error-messages="errors"
            :value="value"
            @change="onInput"
          >
            <v-radio
              :key="k"
              :label="field.label"
              v-for="(field, k) in formdata.fields"
              :value="field.label"
            ></v-radio>
          </v-radio-group>
          <div
            v-if="
              value &&
                selectedValue &&
                selectedValue.subquestion &&
                selectedValue.subquestion.length
            "
            class="pa-5"
          >
            <ValidationObserver ref="observer">
              <div v-for="(item, k) in selectedValue.subquestion" :key="k">
                <FormItemSubquestion
                  v-model="item.value"
                  :formdata="item"
                ></FormItemSubquestion>
              </div>
            </ValidationObserver>
          </div>
        </div>
        <div v-else-if="formdata.questiontype == 'เลื่อนลง'">
          <v-select
            :readonly="isReadonly"
            :disabled="isReadonly"
            :error-messages="errors"
            :value="value"
            outlined
            item-text="label"
            dense
            @change="onInput"
            :items="formdata.fields"
          >
          </v-select>
        </div>
        <div v-else-if="formdata.questiontype == 'วัน/เวลา'">
          <v-row>
            <v-col v-if="['all', 'date'].includes(Options)">
              <div>
                <DatepickerCustom :readonly="isReadonly" v-model="valueData">
                  <v-text-field
                    readonly
                    :disabled="isReadonly"
                    append-icon="mdi-calendar"
                    :error-messages="errors"
                    :value="filteredDate(value)"
                    @input="onInput"
                    outlined
                    dense
                  >
                  </v-text-field>
                </DatepickerCustom></div
            ></v-col>
            <v-col v-if="['all', 'time'].includes(Options)" cols="4">
              <div>
                <TimePickerCustom :readonly="isReadonly" v-model="valueData2">
                  <v-text-field
                    readonly
                    :disabled="isReadonly"
                    append-icon="mdi-clock-time-eight-outline"
                    :error-messages="errors"
                    :value="value2"
                    @input="onInput"
                    outlined
                    dense
                  >
                  </v-text-field>
                </TimePickerCustom></div
            ></v-col>
          </v-row>
        </div>
        <div
          v-else-if="formdata.questiontype == 'ช่องทำเครื่องหมาย'"
          class="mb-10"
        >
          <div :key="k" v-for="(field, k) in formdata.fields">
            <v-checkbox
              :readonly="isReadonly"
              :disabled="isReadonly"
              v-model="nativeSelectedItems"
              :value="field.label"
              @change="onInputArray"
              outlined
              hide-details
              dense
              :error-messages="errors"
              :label="field.label"
            >
            </v-checkbox>

            <div
              v-if="
                nativeSelectedItems.includes(field.label) &&
                  field.subquestion &&
                  field.subquestion.length
              "
              class="pa-5"
            >
              <ValidationObserver ref="observer">
                <div v-for="(item, k) in field.subquestion" :key="k">
                  <FormItemSubquestion
                    v-model="item.value"
                    :formdata="item"
                  ></FormItemSubquestion>
                </div>
              </ValidationObserver>
            </div>
          </div>
          <div
            v-if="errors && errors.length"
            class="error--text v-messages v-messages__message mt-2"
          >
            กรุณาเลือกอย่างน้อย 1 ตัวเลือก
          </div>
        </div>
        <div v-else-if="formdata.questiontype == 'ตัวเลข'">
          <v-text-field
            outlined
            single-line
            dense
            v-model="valueData"
            @keypress="isNumber($event)"
            :readonly="isReadonly"
            :disabled="isReadonly"
            :maxlength="formdata.digitPosition"
          ></v-text-field>
        </div>
        <div v-else-if="formdata.questiontype == 'ตัวอย่างไฟล์'">
          <div class="mx-0 my-4">
            <a :href="formdata.fileurl" flat text target="_blank">
              {{ formdata.filename }}
            </a>
          </div>
        </div>

        <div
          class="mb-6"
          v-else-if="
            ['อัปโหลดเอกสาร', 'อัปโหลดไฟล์', 'อัปโหลดลายเซ็น'].includes(
              formdata.questiontype
            )
          "
        >
          <UploadDocument
            :errors="errors"
            @input="onInput"
            :value="value"
            :readonly="isReadonly"
            :disabled="isReadonly"
            :multiple="formdata.isMultiple"
          ></UploadDocument>
          <div v-for="(item, index) in value" :key="index" style="width: 100%">
            <div class="text-truncate">
              <span
                style="font-weight: 900; color: #5da0c1; cursor: pointer"
                @click="showItem(item)"
              >
                {{ item | showFilename }}
              </span>
            </div>
          </div>
        </div>
      </ValidationProvider>

      <template v-if="formdata.questiontype == 'ที่อยู่'">
        <ValidationProvider
          :vid="vid"
          :name="'บ้านเลขที่'"
          :key="'บ้านเลขที่'"
          :rules="{
            required: formdata.isRequired || true,
          }"
          v-slot="{ errors }"
        >
          <v-textarea
            class="mb-3"
            :readonly="isReadonly"
            :disabled="isReadonly"
            :error-messages="errors"
            :value="address.addressno"
            @input="onInputAddress"
            rows="1"
            outlined
            dense
            placeholder="บ้านเลขที่"
          >
          </v-textarea>
        </ValidationProvider>

        <ValidationProvider
          :vid="vid + '_zipcode'"
          :name="'ไปรษณีย์'"
          :key="'ไปรษณีย์'"
          :rules="{
            required: formdata.isRequired || true,
          }"
          v-slot="{ errors }"
        >
          <ThaiAddressInput
            v-model="address.zipcode"
            type="zipcode"
            @select="onSelectAddress"
            placeholder="ไปรษณีย์"
            data-vv-as="ไปรษณีย์"
            outline
            name="zipcode"
            light
            single-line
            :error-messages="errors"
            :key="'ไปรษณีย์'"
            :rules="{
              required: formdata.isRequired || true,
            }"
          ></ThaiAddressInput>
        </ValidationProvider>

        <ValidationProvider
          :vid="vid + '_province'"
          :name="'จังหวัด'"
          :key="'จังหวัด'"
          :rules="{
            required: formdata.isRequired || true,
          }"
          v-slot="{ errors }"
        >
          <ThaiAddressInput
            v-model="address.province"
            type="province"
            @select="onSelectAddress"
            placeholder="จังหวัด"
            data-vv-as="จังหวัด"
            outline
            name="province"
            light
            :error-messages="errors"
            :rules="{
              required: formdata.isRequired || true,
            }"
          ></ThaiAddressInput>
        </ValidationProvider>

        <ValidationProvider
          :vid="vid + '_amphoe'"
          :name="'เขต/อำเภอ'"
          :key="'เขต/อำเภอ'"
          :rules="{
            required: formdata.isRequired || true,
          }"
          v-slot="{ errors }"
        >
          <ThaiAddressInput
            v-model="address.amphoe"
            type="amphoe"
            @select="onSelectAddress"
            placeholder="เขต/อำเภอ"
            data-vv-as="เขต/อำเภอ"
            outline
            name="amphoe"
            light
            :error-messages="errors"
          ></ThaiAddressInput>
        </ValidationProvider>
        <ValidationProvider
          :vid="vid + '_district'"
          :name="'แขวง/ตำบล'"
          :key="'แขวง/ตำบล'"
          :rules="{
            required: formdata.isRequired || true,
          }"
          v-slot="{ errors }"
        >
          <ThaiAddressInput
            v-model="address.district"
            type="district"
            @select="onSelectAddress"
            placeholder="แขวง/ตำบล"
            data-vv-as="แขวง/ตำบล"
            outline
            name="district"
            light
            :error-messages="errors"
          ></ThaiAddressInput>
        </ValidationProvider>
      </template>
    </div>
  </div>
</template>

<script>
import UploadDocument from "@/components/UploadDocument.vue";
import FormItemSubquestion from "./FormItemSubquestion.vue";
import DatepickerCustom from "@/components/DatepickerCustom.vue";
import TimePickerCustom from "@/components/TimePickerCustom.vue";
import ThaiAddressInput from "@/components/ThaiAddressInput.vue";
import moment from "moment";
export default {
  props: {
    vid: {},
    value: {
      default: null,
    },
    value2: {
      default: null,
    },
    errors: {
      default: null,
    },
    formdata: {
      default: null,
    },
    readonly: {
      default: false,
    },
    Options: {
      default: false,
    },
    Options2: {
      default: false,
    },
    cap: {
      default: false,
    },
    paidcap: {
      default: false,
    },
    shopInfo: {
      default: {},
    },
    productInfo: {
      default: {},
    },
  },
  components: {
    UploadDocument,
    FormItemSubquestion,
    DatepickerCustom,
    TimePickerCustom,
    ThaiAddressInput,
  },
  data() {
    return {
      nativeSelectedItems: this.value ? [...this.value] : [],
      seted: false,
    };
  },

  computed: {
    dpSize() {
      return this.$store.state.dpSize;
    },
    address: {
      get() {
        let val = {
          addressno: "",
          district: "",
          amphoe: "",
          province: "",
          zipcode: "",
        };
        if (this.value) {
          try {
            val = JSON.parse(this.value);
          } catch (error) {}
        }
        return val;
      },
      set(val) {
        this.$emit("input", JSON.stringify(val));
      },
    },
    valueData: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    filteredName() {
      var item = this.$store.state.profiledata;
      if (item.name) {
        return item.name;
      } else if (item.coordinator_name) {
        return item.coordinator_name;
      } else if (item.institute_name) {
        return item.institute_name;
      }
    },
    valueData2: {
      get() {
        return this.value2;
      },
      set(val) {
        this.$emit("update:value2", val);
      },
    },
    isReadonly() {
      return this.query.mode == "readonly" || this.readonly;
    },
    selectedValue() {
      if (this.value) {
        return this.formdata.fields.find((el) => el.label == this.value);
      }
    },
    memberData() {
      return this.$store.state.memberData;
    },
  },
  mounted() {
    this.defaultTextInput();
  },
  watch: {
    Options: {
      deep: true,
      immediate: true,
      handler() {
        if (this.Options2 == "current_date") {
          if (this.Options == "all") {
            this.valueData = moment(new Date()).format("YYYY-MM-DD");
            this.valueData2 = moment(new Date()).format("HH:mm");
          } else if (this.Options == "date") {
            this.valueData = moment(new Date()).format("YYYY-MM-DD");
          } else if (this.Options == "time") {
            this.valueData2 = moment(new Date()).format("HH:mm");
          }
        }
      },
    },
    memberData: {
      deep: true,
      immediate: true,
      handler(memberData) {
        if (memberData && memberData.memberid && this.Options == "u_memberid") {
          this.valueData = this.memberData.memberid;
        }
      },
    },
    cap: {
      handler() {
        if (
          this.cap &&
          this.Options == "regis_cap" &&
          !this.valueData &&
          !this.seted
        ) {
          this.seted = true;
          this.valueData = this.cap;
        }
        if (
          this.cap &&
          this.Options == "RegisterCapital" &&
          !this.valueData &&
          !this.seted
        ) {
          this.seted = true;
          this.valueData = this.cap;
        }
      },
    },
    paidcap: {
      handler() {
        if (
          this.paidcap &&
          this.Options == "PaidRegisterCapital" &&
          !this.valueData &&
          !this.seted
        ) {
          this.seted = true;
          this.valueData = this.paidcap;
        }
      },
    },

    productInfo: {
      deep: true,
      immediate: true,
      handler(productInfo) {
        if (
          productInfo &&
          productInfo.typename &&
          this.Options == "t_product_type" &&
          !this.valueData &&
          !this.seted
        ) {
          this.seted = true;
          this.valueData = productInfo.typename;
          console.log("1", productInfo.typename);
        }
        if (
          productInfo &&
          productInfo.categoryname &&
          this.Options == "t_product_category" &&
          !this.valueData &&
          !this.seted
        ) {
          this.seted = true;
          this.valueData = productInfo.categoryname;
          console.log("2", productInfo.categoryname);
        }
      },
    },
    shopInfo: {
      deep: true,
      handler() {
        if (
          this.shopInfo &&
          this.shopInfo.memberid &&
          this.Options == "shop_memberid" &&
          !this.valueData &&
          !this.seted
        ) {
          this.seted = true;
          this.valueData = this.shopInfo.memberid;
        }
        if (
          this.shopInfo &&
          this.shopInfo.JuristicID &&
          this.Options == "shop_juristic_id" &&
          !this.valueData &&
          !this.seted
        ) {
          this.seted = true;
          this.valueData = this.shopInfo.JuristicID;
        }
      },
    },
    valueData: {
      handler() {
        if (
          this.cap &&
          this.Options == "regis_cap" &&
          !this.valueData &&
          !this.seted
        ) {
          this.seted = true;
          this.valueData = this.cap;
        }
        if (
          this.cap &&
          this.Options == "RegisterCapital" &&
          !this.valueData &&
          !this.seted
        ) {
          this.seted = true;
          this.valueData = this.cap;
        }

        if (
          this.paidcap &&
          this.Options == "PaidRegisterCapital" &&
          !this.valueData &&
          !this.seted
        ) {
          this.seted = true;
          this.valueData = this.paidcap;
        }
        if (
          this.shopInfo &&
          this.shopInfo.memberid &&
          this.Options == "shop_memberid" &&
          !this.valueData &&
          !this.seted
        ) {
          this.seted = true;
          this.valueData = this.shopInfo.memberid;
        }
        if (
          this.shopInfo &&
          this.shopInfo.JuristicID &&
          this.Options == "shop_juristic_id" &&
          !this.valueData &&
          !this.seted
        ) {
          this.seted = true;
          this.valueData = this.shopInfo.JuristicID;
        }
      },
    },
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onSelectAddress(address) {
      this.address = {
        ...this.address,
        ...address,
      };
    },
    defaultTextInput() {
      if (
        !this.valueData &&
        this.Options &&
        ["ข้อความ", "กล่องข้อความ", "คำตอบสั้นๆ"].includes(
          this.formdata.questiontype
        )
      ) {
        if (this.Options == "project_name") {
          this.valueData = this.$store.state.projects.projectname;
        } else if (this.Options == "name") {
          this.valueData = this.filteredName;
        } else if (this.Options == "regis_cap") {
          this.valueData = this.cap;
        } else if (this.Options == "t_shop_name") {
          this.valueData = this.query.t_shop_name ? this.query.t_shop_name : "";
        } else if (this.Options == "t_product") {
          this.valueData = this.query.t_product ? this.query.t_product : "";
        } else if (this.Options == "t_product_voucher") {
          this.valueData = this.query.t_product_voucher
            ? this.query.t_product_voucher
            : "";
        } else if (this.Options == "farmer_number") {
          this.valueData = this.memberData.profile_center_id
            ? this.memberData.profile_center_id
            : "";
        } else if (this.Options == "agency") {
          this.valueData =
            this.$store.state.agency && this.$store.state.agency.agencyname
              ? this.$store.state.agency.agencyname
              : "";
        } else if (this.Options == "u_memberid") {
          this.valueData =
            this.memberData && this.memberData.memberid
              ? this.memberData.memberid
              : "";
        } else if (this.Options == "t_product_type") {
          this.valueData =
            this.productInfo && this.productInfo.typename
              ? this.productInfo.typename
              : "";
        } else if (this.Options == "t_product_category") {
          this.valueData =
            this.productInfo && this.productInfo.categoryname
              ? this.productInfo.categoryname
              : "";
        } else {
          if (this.Options.includes("id_card")) {
            this.Options = "id_card";
          }
          if (this.Options.includes("membertype")) {
            this.Options = "membertype";
          }

          this.valueData = this.$store.state.profiledata[this.Options];
        }
      } else if (!this.valueData && this.formdata.defaultOptions) {
        if (this.formdata.questiontype == "ช่องทำเครื่องหมาย") {
          let defaultOptiones = this.formdata.defaultOptions.filter((el) => {
            return this.formdata.fields.some((el) => el.label);
          });

          this.valueData = defaultOptiones;
          this.nativeSelectedItems = defaultOptiones;
          this.onInputArray();
        } else if (this.formdata.questiontype == "หลายตัวเลือก") {
          let defaultOptiones = this.formdata.fields.find(
            (el) => el.label == this.formdata.defaultOptions
          );

          this.valueData = defaultOptiones ? defaultOptiones.label : "";
        }
      }
    },
    filteredDate(date) {
      if (date) {
        return moment(date).format("DD/MM/YYYY");
      } else return "";
    },
    showItem(item) {
      this.$liff.openWindow({
        url: item,
        external: true,
      });
    },
    onInput(e) {
      this.$emit("input", e);
    },
    onInputAddress(e) {
      this.address.addressno = e;
    },
    onInputArray(e) {
      this.$emit("input", this.nativeSelectedItems);
    },
  },
  filters: {
    showFilename(value) {
      var result = value;
      if (result) {
        result = result.split("/");
        result = result[4].substring(13);
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped></style>
